import {greenColors, orangeColors, primary} from '../layouts/theme/designSystem';
import {MatchStatus} from '../types/MatchStatus/MatchStatus';
import {CamelCaseMatchStatusTab, MatchStatusTab} from '../types/shared-recruiting-types';

const matchColor: Record<MatchStatus, string> = {
  [MatchStatus.New]: greenColors[40],
  [MatchStatus.Accepted]: greenColors[40],
  [MatchStatus.Contacted]: greenColors[100],
  [MatchStatus.Pending]: greenColors[100],
  [MatchStatus.Interview]: orangeColors[40],
  [MatchStatus.Hired]: orangeColors[100],
  // unsure what rejected color should be.
  [MatchStatus.Rejected]: primary[50],
  // making on hold color the same as rejected for now.
  [MatchStatus.OnHold]: primary[50],
};
export const getMatchStatusColor = (status: MatchStatus): string => {
  return matchColor[status];
};

export const snakeToCamel = (value: MatchStatusTab): CamelCaseMatchStatusTab => {
  switch (value) {
    case 'on_hold':
      return 'onHold';
    default:
      return value;
  }
};

export const camelToSnake = (value: CamelCaseMatchStatusTab): MatchStatusTab => {
  switch (value) {
    case 'onHold':
      return 'on_hold';
    default:
      return value;
  }
};
